import gql from 'graphql-tag'
import { DollarApollo } from 'vue-apollo/types/vue-apollo'

export const typeDefs = gql`
  type Snackbar {
    show: Boolean!
    text: String
    color: String
    timeout: Int!
    top: Boolean
    bottom: Boolean
  }
  extend type Query {
    snackbar: Snackbar
  }
  extend type Mutation {
    updateSnackbar(
      text: String!
      color: String
      timeout: Int
      top: Boolean
      bottom: Boolean
    ): Snackbar
  }
`
const defaultColor = `primary`
const defaultTimeout = 3500
const defaultTop = false
const defaultBottom = true

export const resolvers = {
  Query: {
    snackbar(_: any, __: any, { cache }: { cache: any }) {
      return cache.readQuery({ query })
    }
  },
  Mutation: {
    updateSnackbar: (
      _: any,
      { text, color, timeout, top, bottom }: MutateSnackbarOptions,
      { cache }: { cache: any }
    ) => {
      const { snackbar } = cache.readQuery({ query })
      snackbar.show = true
      snackbar.text = text
      snackbar.color = color || defaultColor
      snackbar.timeout = timeout || defaultTimeout
      snackbar.top = top || defaultTop
      snackbar.bottom =
        !top && bottom ? bottom : bottom ? bottom : top ? false : defaultBottom
    }
  }
}

export const hydrate = {
  snackbar: {
    __typename: `Snackbar`,
    show: false,
    text: ``,
    color: defaultColor,
    timeout: defaultTimeout,
    top: defaultTop,
    bottom: defaultBottom
  }
}

export const query = gql`
  query {
    snackbar @client {
      show
      text
      color
      timeout
    }
  }
`

export const mutation = gql`
  mutation($text: String!, $color: String, $bottom: Boolean, $top: Boolean) {
    updateSnackbar(text: $text, color: $color, bottom: $bottom, top: $top)
      @client
  }
`

export default {
  typeDefs,
  resolvers,
  hydrate
}

export const mutateSnackbar = (
  { text, color, timeout, top, bottom }: MutateSnackbarOptions,
  apollo: DollarApollo<any>
) => {
  apollo.mutate({
    mutation,
    variables: { text, color, timeout, top, bottom }
  })
}

export interface MutateSnackbarOptions {
  text: string
  color?: string
  timeout?: number
  top?: boolean
  bottom?: boolean
}
